import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { RENTAL_WIDGET, TOUR_WIDGET } from 'lib/utils/mainWidgetConstants';
import { Typography700 } from 'views/rebranded-module/common/components/UI/Typography700';
import StyledBox, {
  StyledTabs,
  StyledTab,
} from 'views/rebranded-module/common/components/UI/NewMainWidget/NewWidgetTitle/NewWidgetTitle.styles';
import { useContent } from 'views/rebranded-module/common/context/useContent';

const NewWidgetTitle = (props) => {
  const {
    widgetInfo,
    titleColor,
    handleWidgetTypeSelect,
    className,
    renderAllProductOptions = true,
    selectedTourType,
    showStartYourAdventureLabel = true,
    vertical
  } = props;
  const cmsData = useContent();

  const widgetTitle = useMemo(() => {
    switch (widgetInfo.type) {
      case TOUR_WIDGET:
        return selectedTourType?.name;
      case RENTAL_WIDGET:
      default:
        return cmsData.NewMainWidgetComponent.rentMotorcycle;
    }
  }, [widgetInfo, selectedTourType, cmsData]);

  const handleWidgetTabSelect = (e: any, selectedType: string) => {
    handleWidgetTypeSelect(selectedType);
  };

  return (
    <StyledBox className={`${className || ''} WTContainer ${vertical? 'NWTVertical': ''}`} >
      <Box className="WTTitleContainer">
        {showStartYourAdventureLabel && (
          <Typography700
            component="p"
            variant="overline2"
            color="primary"
            className="WTSubTitle">
            {cmsData.MainWidgetDialogComponent.startYourAdventureLabel}
          </Typography700>
        )}
        <Typography700
          component="p"
          variant="h7"
          className="MTTitle"
          sx={{ color: titleColor && `${titleColor}!important` }}>
          {widgetTitle}
        </Typography700>
      </Box>
      <StyledTabs value={widgetInfo.type} onChange={handleWidgetTabSelect} className={`${vertical? 'NWTVertical': ''}`}>
        <StyledTab
          label={cmsData.NewMainWidgetComponent.rentalTabLabel}
          value={RENTAL_WIDGET}
        />
        <StyledTab
          disabled={!renderAllProductOptions}
          label={cmsData.NewMainWidgetComponent.tourTabLabel}
          value={TOUR_WIDGET}
        />
      </StyledTabs>
    </StyledBox>
  );
};

export { NewWidgetTitle };
